import React, { Component, Fragment } from "react";
import styles from "./AccountCard.module.less";
import { Link } from "react-router";
import { DetailListItem } from "assets/scripts/components/presentational/DetailList/DetailList";
import { defineMessages, FormattedNumber, FormattedDate, FormattedMessage, injectIntl } from "react-intl";
import Relationship from "assets/scripts/components/presentational/Relationship/Relationship";
import RouteTable from "./RouteTable/RouteTable";
import { getRoutePaymentStatus } from "assets/scripts/domain/payment/paymentUtils";
import moment from "moment";
import AccountCardWrapper from "assets/scripts/components/presentational/AccountCardWrapper/AccountCardWrapper";
import isSettlementEligible from "assets/scripts/domain/accts/isSettlementEligible";
import Icon from "assets/scripts/components/presentational/Icon";
import MDPatientSheet from "assets/scripts/components/common/MDPatientSheet/MDPatientSheet";
const messages = defineMessages({
    referenceNumber: {
        id: "dashboard.accountList.accountCard.referenceNumber",
        defaultMessage: "Reference #"
    },
    // accountNumber: {
    // 	id: "dashboard.accountList.accountCard.accountNumber",
    // 	defaultMessage: "Account #"
    // },
    decedentLastName: {
        id: "dashboard.accountList.accountCard.decedentLastName",
        defaultMessage: "Decedent Last Name"
    },
    relationship: {
        id: "dashboard.accountList.accountCard.relationship",
        defaultMessage: "Relationship"
    },
    // creditor: {
    // 	id: "dashboard.accountList.accountCard.creditor",
    // 	defaultMessage: "Creditor"
    // },
    balance: {
        id: "dashboard.accountList.accountCard.balance",
        defaultMessage: "Balance"
    },
    totalBalance: {
        id: "dashboard.accountList.accountCard.totalBalance",
        defaultMessage: "Total Balance"
    },
    amountDue: {
        id: "dashboard.accountList.accountCard.amountDue",
        defaultMessage: "Amount Due*"
    },
    schedulePayment: {
        id: "dashboard.accountList.accountCard..schedulePayment",
        defaultMessage: "Schedule a Payment"
    },
    makePayment: {
        id: "dashboard.accountList.accountCard..makePayment",
        defaultMessage: "Make a Payment"
    },
    settlementAgreement: {
        id: "dashboard.accountList.accountCard.settlementAgreement",
        defaultMessage: "Settlement Agreement"
    },
    settlementOffer: {
        id: "dashboard.accountList.accountCard.settlementOffer",
        defaultMessage: "Settlement Offer"
    },
    monthlyPayment: {
        id: "dashboard.accountList.accountCard.monthlyPayment",
        defaultMessage: "Monthly Payment"
    },
    paymentDueDate: {
        id: "dashboard.accountList.accountCard.paymentDueDate",
        defaultMessage: "Payment Due Date"
    },
    nextPaymentDueDate: {
        id: "dashboard.accountList.accountCard.nextPaymentDueDate",
        defaultMessage: "Next Payment Due Date"
    },
});
class AccountCard extends Component {
    render() {
        const { props } = this;
        const group = props.routeGroup;
        const balanceMessage = group.accounts.length === 1 ? messages.balance : messages.totalBalance;
        const disclaimerIds = (group.disclaimer != null && !!group.disclaimer.filter(it => !!it).length && group.disclaimer.filter(it => !!it).map(it => props.disclaimerIdMap[it])) || null;
        const { paymentAllowed } = getRoutePaymentStatus(group, moment());
        const paymentLabel = group.primary.allowScheduledPayment ? messages.schedulePayment : messages.makePayment;
        const settlementEligible = paymentAllowed && isSettlementEligible(group);
        const paymentDueDate = group.primary.paymentDueDate == null ? null : moment(group.primary.paymentDueDate);
        const showMonthlyPayment = group.primary.monthlyPayment != null && group.primary.monthlyPayment > 0;
        return (<AccountCardWrapper data-test="AccountCard" role="group" aria-label="Account">
				<AccountCardWrapper.Content>
					<div>
						<AccountCardWrapper.Title group={group} disclaimerIds={disclaimerIds}/>

						{group.open && (<div className={styles.balance}>
								<span aria-label={this.props.intl.formatMessage(balanceMessage)}>
									<FormattedNumber value={group.balance} style="currency" currency="USD"/>
								</span>
								<span className={styles.balanceLabel}>
									<FormattedMessage {...balanceMessage}/>
								</span>
							</div>)}

						{!group.open && (<div className={styles.closed}>
								<FormattedMessage id="dashboard.accountList.accountCard.accountClosed" defaultMessage="Account has been closed with DCM Services"/>
							</div>)}

						{!!group.primary.supportEmail && (<div className={styles.email}>
								<div>
									<FormattedMessage id="email.support.emailUs" defaultMessage="Have a question?"/>
								</div>
								<div>
									<a 
        // tslint:disable-next-line:max-line-length
        href={`mailto:${group.primary.supportEmail}?subject=${encodeURIComponent(`${group.primary.deceased ? "Estate of" : "Account for"} ${group.primary.firstName} ${group.primary.lastName}: Reference #${group.primary.refNum}`)}`} className="link">
										<Icon icon="email"/>
										{group.primary.supportEmail}
									</a>
								</div>
							</div>)}
					</div>

					<AccountCardWrapper.Details refNum={group.primary.refNum}>
						{group.primary.deceased && (<Fragment>
								{group.decLastName != null && (<DetailListItem label={messages.decedentLastName}>
										{group.decLastName}
									</DetailListItem>)}
								<DetailListItem label={messages.relationship}>
									<Relationship className={styles.relationship} account={group.primary} openModal={props.openModal} setAccountToEdit={props.setAccountToEdit}/>
								</DetailListItem>
							</Fragment>)}
						{group.accounts.length === 1 && !group.primary.accountClosed && (<Fragment>
								{group.primary.settlementAgreement != null && group.primary.settlementAgreement > 0 && (<DetailListItem label={messages.settlementAgreement}>
										<FormattedNumber value={group.primary.settlementAgreement} style="currency" currency="USD"/>
									</DetailListItem>)}
								{group.primary.settlementOffer != null && group.primary.settlementOffer > 0 && (<DetailListItem label={messages.settlementOffer}>
										<FormattedNumber value={group.primary.settlementOffer} style="currency" currency="USD"/>
									</DetailListItem>)}
								{showMonthlyPayment && (<DetailListItem label={messages.monthlyPayment}>
										<FormattedNumber value={group.primary.monthlyPayment} style="currency" currency="USD"/>
									</DetailListItem>)}
								{paymentDueDate != null && !paymentDueDate.isBefore(moment().startOf("day")) && (<DetailListItem label={showMonthlyPayment ? messages.nextPaymentDueDate : messages.paymentDueDate}>
										<FormattedDate value={paymentDueDate.toDate()}/>
									</DetailListItem>)}
							</Fragment>)}
					</AccountCardWrapper.Details>
				</AccountCardWrapper.Content>

				{group.accounts.length > 1 && (<div className="vr vr_x2">
						<RouteTable group={group} showDecLastName={group.decLastName == null} disclaimerIdMap={props.disclaimerIdMap} showDisclaimerIds={disclaimerIds == null}/>
					</div>)}

				{group.primary.hasMDPatientInfoSheet && (<MDPatientSheet clientId={group.primary.clientId} clientName={group.primary.clientName} hasSpanish={group.primary.hasMDPatientInfoSheetES} addlStyles={styles.mdSheet}/>)}

				<ul className={styles.actions}>
					<li>
						<Link to={`/secured/account/${group.primary.id}`} className="link">
							<span data-test={`refNum-${group.primary.refNum}`}>
								<FormattedMessage id="dashboard.accountList.accountCard.action.viewDetails" defaultMessage="View Details"/>
							</span>
						</Link>
					</li>

					{(group.primary.allowCallback || group.callbackAccount.callback != null) && (<li>
							<Link to={`/secured/callback/${group.primary.id}`} className="link">
								{group.callbackAccount.callback == null && (<FormattedMessage id="dashboard.accountList.accountCard.action.requestCallback" defaultMessage="Request a Callback"/>)}
								{group.callbackAccount.callback != null && (<FormattedMessage id="dashboard.accountList.accountCard.action.viewCallback" defaultMessage="View Upcoming Callback"/>)}
							</Link>
						</li>)}

					{paymentAllowed && (<li>
							<Link to={`/secured/payNow/${group.primary.id}`} className="link">
								<FormattedMessage {...paymentLabel}/>
							</Link>
						</li>)}

					{settlementEligible && (<li>
							<Link to={`/secured/settlement/${group.primary.id}`} className="link">
								<FormattedMessage id="dashboard.accountList.accountCard.action.settlementOptions" defaultMessage="Settlement Options"/>
							</Link>
						</li>)}
				</ul>
			</AccountCardWrapper>);
    }
}
export default injectIntl(AccountCard);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountCard/AccountCard.tsx